'use strict';

var GetIntrinsic = require('get-intrinsic');

var $abs = GetIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function abs(x) {
	return $abs(x);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2021/abs.js
// module id = OfgZ
// module chunks = 78